<template>

  <div>

    <v-layout justify-space-between>

      <v-flex v-for="(item, index) in models[selectionType]" :key="index">

        <WizardCard class="pointer"
                    :selection-type="selectionType"
                    :item="item"
                    :color="item.color || colorGradient[index]"
                    :category="category"
                    @card-clicked="handleCardClick">

          <div>
            <v-icon v-for="i in item.iconCount || item.number" :key="i" :size="item.iconSize">
              {{item.mdIcon}}
            </v-icon>
          </div>

          <h3 :class="labelClass">{{item.text}}</h3>

        </WizardCard>

      </v-flex>

    </v-layout>

  </div>

</template>

<script>
import WizardCard from './Wizard.Card.vue';

export default {

  name: 'Wizard.Step',

  components: { WizardCard },

  props: {
    selectionType: {
      type: String,
      required: true,
    },
    itemHeight: {
      type: Number,
      required: false,
      default: 130,
    },
    labelClass: {
      type: String,
      required: false,
      default: 'display-1',
    },
    category: {
      type: Object,
      required: false,
    },
  },

  data() {
    return {
      models: this.$store.getters.models,
      colorGradient: [],
    };
  },

  mounted() {
    this.generateColorGradient();
  },

  methods: {

    handleCardClick($event) {
      const update = { ...this.$store.state.wizard.preferences };
      update[$event.key] = $event.value;
      this.$store.dispatch('setPreferences', update);
      this.$emit('increment-step');
    },

    generateColorGradient() {
      if (this.models[this.selectionType]) {
        this.colorGradient = this.$helpers.generateColorGradient({
          count: this.models[this.selectionType].length,
          seed: `wizard-${this.selectionType}-1`,
        });
      }
    },

  },

  watch: {

    items() {
      this.generateColorGradient();
    },

  },

};
</script>
